import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AwardsService } from '../services';
import { awardsKeys } from '../queryKeys';

export const useCreateCycle = (options = {}) => {
  const { onSuccess, onError } = options;
  const queryClient = useQueryClient();

  return useMutation({
    // The 409 overlap error renders inline on the date fields, so the global
    // toaster must not also fire.
    meta: { skipGlobalErrorToaster: true },
    mutationFn: (payload) => AwardsService.createCycle(payload),
    onSuccess: (cycle) => {
      queryClient.invalidateQueries({ queryKey: awardsKeys.all });
      onSuccess?.(cycle);
    },
    onError,
  });
};
